import { useState, useEffect } from "react";
import { api } from "../utils/api";
import {
  Bike, Plus, Phone, Check, X, Loader2,
  ToggleLeft, ToggleRight, RefreshCw, CheckCircle, Mail,
  Wifi, WifiOff, Wallet, IndianRupee, Clock, CheckCircle2,
  XCircle, ChevronDown, ChevronUp,
} from "lucide-react";

const T = {
  primary:"#f97316", primaryDark:"#ea580c", primaryLight:"#fff7ed", primaryMid:"#fed7aa",
  white:"#ffffff", bg:"#f1f5f9", text:"#0f172a", textSub:"#64748b", textMuted:"#94a3b8",
  border:"#e2e8f0", green:"#16a34a", greenLight:"#dcfce7", red:"#ef4444", redLight:"#fef2f2",
  yellow:"#f59e0b", yellowLight:"#fefce8", blueLight:"#eff6ff", blue:"#2563eb",
};

const EMPTY = {
  name:"", phone:"", email:"", area:"",
  vehicleType:"bike", vehicleNo:"", isActive:true, isOnline:false,
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// RIDER MODAL
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function RiderModal({ rider, onClose, onSave }) {
  const [form,   setForm]   = useState(rider || EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.name || !form.phone) return alert("Name aur phone required hai!");
    if (!form.email) return alert("Email required hai — OTP login ke liye!");
    setSaving(true);
    const res = form._id
      ? await api.riders.update(form._id, form)
      : await api.riders.create(form);
    setSaving(false);
    if (res.success) onSave(res.data, !!form._id);
    else alert(res.message || "Error!");
  };

  const fields = [
    { label:"Full Name *", key:"name",     type:"text",  placeholder:"Suresh Kumar"       },
    { label:"Phone *",     key:"phone",     type:"text",  placeholder:"9812345678"         },
    { label:"Email *",     key:"email",     type:"email", placeholder:"rider@example.com"  },
    { label:"Area",        key:"area",      type:"text",  placeholder:"Civil Lines, Akola" },
    { label:"Vehicle No",  key:"vehicleNo", type:"text",  placeholder:"MH-20 AB 1234"      },
  ];

  return (
    <div onClick={onClose} style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:400,display:"flex",alignItems:"center",justifyContent:"center",padding:16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:T.white,borderRadius:20,width:"100%",maxWidth:440,boxShadow:"0 20px 60px rgba(0,0,0,0.15)",overflow:"hidden",maxHeight:"90vh",overflowY:"auto" }}>
        <div style={{ padding:"16px 18px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,background:T.white,zIndex:10 }}>
          <div style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1rem",color:T.text }}>
            {form._id ? "Edit Rider" : "Add New Rider"}
          </div>
          <button onClick={onClose} style={{ background:T.bg,border:"none",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer" }}>
            <X size={15} color={T.textSub}/>
          </button>
        </div>
        <div style={{ padding:18,display:"flex",flexDirection:"column",gap:12 }}>
          <div style={{ background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:10,padding:"9px 12px",display:"flex",alignItems:"center",gap:8 }}>
            <Mail size={14} color={T.blue}/>
            <span style={{ fontSize:"0.75rem",color:T.blue,fontWeight:600 }}>
              Email zaroori hai — Rider isi se OTP login karega
            </span>
          </div>
          {fields.map(f => (
            <div key={f.key}>
              <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>
                {f.label}
              </label>
              <input
                value={form[f.key] || ""}
                onChange={e => set(f.key, e.target.value)}
                placeholder={f.placeholder}
                type={f.type}
                style={{ width:"100%",border:`1.5px solid ${f.key==="email"?T.primary:T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,outline:"none",boxSizing:"border-box",background:f.key==="email"?T.primaryLight:"#fff" }}
              />
            </div>
          ))}
          <div>
            <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Vehicle Type</label>
            <select value={form.vehicleType} onChange={e => set("vehicleType", e.target.value)}
              style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,background:T.white }}>
              <option value="bike">Bike</option>
              <option value="scooter">Scooter</option>
              <option value="bicycle">Bicycle</option>
            </select>
          </div>
          <button onClick={handleSave} disabled={saving}
            style={{ background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,border:"none",borderRadius:12,padding:"11px",color:"#fff",fontWeight:800,fontSize:"0.88rem",cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:6,marginTop:4,opacity:saving?0.8:1 }}>
            {saving ? <><Loader2 size={16} className="spin"/> Saving...</> : <><Check size={16}/> {form._id ? "Save Changes" : "Add Rider"}</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// CASH WALLET MODAL — Admin view for a rider
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function CashModal({ rider, onClose, onApproved }) {
  const [deposits,   setDeposits]   = useState(rider.cashDeposits || []);
  const [cashBal,    setCashBal]    = useState(rider.cashBalance || 0);
  const [loading,    setLoading]    = useState(false);
  const [actionId,   setActionId]   = useState(null);

  const BASE = import.meta.env.VITE_API_URL || "http://localhost:5000/api";

  const doAction = async (depositId, action) => {
    setActionId(depositId);
    try {
      const url = `${BASE}/riders/${rider._id}/cash/${action}/${depositId}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
        body: JSON.stringify({ reason: "Rejected by admin" }),
      });
      const data = await res.json();
      if (data.success) {
        setCashBal(data.cashBalance);
        setDeposits(prev => prev.map(d =>
          d._id === depositId ? { ...d, status: action === "approve" ? "approved" : "rejected" } : d
        ));
        onApproved(rider._id, data.cashBalance);
      } else {
        alert(data.message || "Error");
      }
    } catch { alert("Network error"); }
    setActionId(null);
  };

  const pending  = deposits.filter(d => d.status === "pending");
  const resolved = deposits.filter(d => d.status !== "pending");

  return (
    <div onClick={onClose} style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:T.white,borderRadius:20,width:"100%",maxWidth:480,boxShadow:"0 20px 60px rgba(0,0,0,0.2)",maxHeight:"88vh",overflowY:"auto" }}>

        {/* Header */}
        <div style={{ padding:"16px 18px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,background:T.white,zIndex:10 }}>
          <div>
            <div style={{ fontWeight:900,fontSize:"1rem",color:T.text }}>💰 Cash Wallet</div>
            <div style={{ fontSize:"0.75rem",color:T.textSub,marginTop:2 }}>{rider.name} · {rider.phone}</div>
          </div>
          <button onClick={onClose} style={{ background:T.bg,border:"none",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer" }}>
            <X size={15} color={T.textSub}/>
          </button>
        </div>

        <div style={{ padding:18 }}>
          {/* Cash Balance */}
          <div style={{ background:"linear-gradient(135deg,#f97316,#ea580c)",borderRadius:16,padding:18,marginBottom:16,color:"#fff" }}>
            <div style={{ fontSize:"0.75rem",opacity:0.8,marginBottom:4 }}>PENDING CASH TO DEPOSIT</div>
            <div style={{ fontSize:32,fontWeight:900 }}>₹{cashBal}</div>
            <div style={{ fontSize:"0.72rem",opacity:0.75,marginTop:4 }}>COD orders ka collected cash</div>
          </div>

          {/* Pending Requests */}
          {pending.length > 0 && (
            <div style={{ marginBottom:16 }}>
              <div style={{ fontWeight:700,fontSize:"0.85rem",color:T.text,marginBottom:10,display:"flex",alignItems:"center",gap:6 }}>
                <Clock size={14} color={T.yellow}/> Pending Requests ({pending.length})
              </div>
              {pending.map(d => (
                <div key={d._id} style={{ background:T.yellowLight,border:`1px solid #fde68a`,borderRadius:12,padding:14,marginBottom:10 }}>
                  <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8 }}>
                    <div>
                      <div style={{ fontWeight:800,fontSize:"1rem",color:T.text }}>₹{d.amount}</div>
                      <div style={{ fontSize:"0.72rem",color:T.textSub,marginTop:2 }}>
                        {d.method === "upi" ? "📱 UPI Transfer" : "🏪 Store Visit"}
                        {d.upiRef && <span style={{ marginLeft:6,fontWeight:700 }}>Ref: {d.upiRef}</span>}
                      </div>
                      <div style={{ fontSize:"0.68rem",color:T.textMuted,marginTop:2 }}>
                        {new Date(d.createdAt).toLocaleString("en-IN")}
                      </div>
                      {d.note && <div style={{ fontSize:"0.72rem",color:T.textSub,marginTop:4 }}>Note: {d.note}</div>}
                    </div>
                    <div style={{ background:T.yellowLight,border:`1px solid #fde68a`,borderRadius:8,padding:"3px 8px",fontSize:"0.65rem",fontWeight:700,color:T.yellow }}>
                      PENDING
                    </div>
                  </div>
                  <div style={{ display:"flex",gap:8 }}>
                    <button
                      onClick={() => doAction(d._id, "approve")}
                      disabled={actionId === d._id}
                      style={{ flex:1,background:T.green,border:"none",borderRadius:9,padding:"9px",color:"#fff",fontWeight:700,fontSize:"0.8rem",cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:5 }}>
                      {actionId === d._id ? <Loader2 size={13} className="spin"/> : <CheckCircle2 size={13}/>}
                      Approve
                    </button>
                    <button
                      onClick={() => doAction(d._id, "reject")}
                      disabled={actionId === d._id}
                      style={{ flex:1,background:T.redLight,border:`1px solid #fecaca`,borderRadius:9,padding:"9px",color:T.red,fontWeight:700,fontSize:"0.8rem",cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:5 }}>
                      <XCircle size={13}/> Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {pending.length === 0 && (
            <div style={{ textAlign:"center",padding:"20px 0",color:T.textMuted,fontSize:"0.82rem" }}>
              ✅ No pending deposit requests
            </div>
          )}

          {/* History */}
          {resolved.length > 0 && (
            <div>
              <div style={{ fontWeight:700,fontSize:"0.85rem",color:T.text,marginBottom:10 }}>
                History ({resolved.length})
              </div>
              {resolved.slice(0,10).map(d => (
                <div key={d._id} style={{ display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 12px",background:T.bg,borderRadius:10,marginBottom:6 }}>
                  <div>
                    <div style={{ fontWeight:700,fontSize:"0.85rem",color:T.text }}>₹{d.amount}</div>
                    <div style={{ fontSize:"0.68rem",color:T.textSub }}>
                      {d.method === "upi" ? "📱 UPI" : "🏪 Store"} · {new Date(d.createdAt).toLocaleDateString("en-IN")}
                    </div>
                  </div>
                  <div style={{
                    fontSize:"0.65rem",fontWeight:700,padding:"3px 8px",borderRadius:100,
                    background: d.status === "approved" ? T.greenLight : T.redLight,
                    color: d.status === "approved" ? T.green : T.red,
                  }}>
                    {d.status === "approved" ? "✓ Approved" : "✗ Rejected"}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// MAIN PAGE
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
export default function Riders() {
  const [riders,      setRiders]      = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [modal,       setModal]       = useState(null);   // "add" | rider obj
  const [cashModal,   setCashModal]   = useState(null);   // rider obj
  const [toast,       setToast]       = useState("");
  const [lastRefresh, setLastRefresh] = useState(new Date());
  const [countdown,   setCountdown]   = useState(30);
  const [activeTab,   setActiveTab]   = useState("riders"); // "riders" | "cash"

  const showToast = m => { setToast(m); setTimeout(() => setToast(""), 2200); };

  const load = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const res = await api.riders.getAll();
      if (res.success) {
        setRiders(res.data);
        setLastRefresh(new Date());
        setCountdown(30);
      }
    } catch { if (!silent) showToast("Backend connect nahi hua"); }
    finally { if (!silent) setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  useEffect(() => {
    const interval = setInterval(() => { load(true); }, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const t = setInterval(() => { setCountdown(c => c <= 1 ? 30 : c - 1); }, 1000);
    return () => clearInterval(t);
  }, []);

  const handleToggleActive = async (id) => {
    const res = await api.riders.toggle(id);
    if (res.success) { setRiders(r => r.map(x => x._id === id ? res.data : x)); showToast("Updated!"); }
  };

  const handleToggleOnline = async (r) => {
    const res = await api.riders.update(r._id, { isOnline: !r.isOnline });
    if (res.success) { setRiders(prev => prev.map(x => x._id === r._id ? res.data : x)); showToast("Status updated!"); }
  };

  const handleVerify = async (id) => {
    const res = await api.riders.verify(id);
    if (res.success) { setRiders(r => r.map(x => x._id === id ? res.data : x)); showToast("Rider verified!"); }
  };

  const handleSave = (data, isEdit) => {
    setRiders(r => isEdit ? r.map(x => x._id === data._id ? data : x) : [data, ...r]);
    setModal(null);
    showToast(isEdit ? "Rider updated!" : "Rider added!");
  };

  const handleCashApproved = (riderId, newBalance) => {
    setRiders(prev => prev.map(r =>
      r._id === riderId ? { ...r, cashBalance: newBalance } : r
    ));
    showToast("Deposit processed!");
  };

  // Stats
  const onlineCount   = riders.filter(r => r.isOnline).length;
  const totalCash     = riders.reduce((s, r) => s + (r.cashBalance || 0), 0);
  const pendingDeposits = riders.reduce((s, r) =>
    s + (r.cashDeposits || []).filter(d => d.status === "pending").length, 0);
  const ridersWithCash = riders.filter(r => (r.cashBalance || 0) > 0);

  return (
    <div style={{ padding:"20px 16px",maxWidth:960,margin:"0 auto",fontFamily:"'Inter',system-ui,sans-serif" }}>
      <style>{`
        @keyframes fadeUp { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes spin { to{transform:rotate(360deg)} }
        .spin { animation: spin 0.75s linear infinite; }
        .pulse { animation: pulse 1.5s infinite; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
      `}</style>

      {/* Toast */}
      {toast && (
        <div style={{ position:"fixed",top:16,right:16,background:T.text,color:"#fff",padding:"10px 18px",borderRadius:12,fontWeight:700,fontSize:"0.82rem",zIndex:999,boxShadow:"0 4px 20px rgba(0,0,0,0.2)" }}>
          {toast}
        </div>
      )}

      {/* Header */}
      <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20 }}>
        <div>
          <h1 style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1.4rem",color:T.text,margin:0 }}>
            🛵 Riders
          </h1>
          <div style={{ fontSize:"0.72rem",color:T.textMuted,marginTop:4 }}>
            {riders.length} total · {onlineCount} online · Refresh in {countdown}s
          </div>
        </div>
        <div style={{ display:"flex",gap:8 }}>
          <button onClick={() => load()} style={{ background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"8px 12px",cursor:"pointer",display:"flex",alignItems:"center",gap:5,fontSize:"0.78rem",fontWeight:600,color:T.textSub,fontFamily:"inherit" }}>
            <RefreshCw size={13}/> Refresh
          </button>
          <button onClick={() => setModal("add")} style={{ background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,border:"none",borderRadius:10,padding:"8px 16px",cursor:"pointer",display:"flex",alignItems:"center",gap:5,fontSize:"0.82rem",fontWeight:700,color:"#fff",fontFamily:"inherit" }}>
            <Plus size={14}/> Add Rider
          </button>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:10,marginBottom:18 }}>
        {[
          { label:"Total Riders", value:riders.length,  color:T.text,   bg:T.bg          },
          { label:"Online Now",   value:onlineCount,    color:T.green,  bg:T.greenLight  },
          { label:"Cash Pending", value:`₹${totalCash}`,color:T.primary,bg:T.primaryLight},
          { label:"Deposit Reqs", value:pendingDeposits,color:T.yellow, bg:T.yellowLight },
        ].map(s => (
          <div key={s.label} style={{ background:s.bg,borderRadius:12,padding:"12px 14px",border:`1px solid ${T.border}` }}>
            <div style={{ fontWeight:800,fontSize:"1.1rem",color:s.color }}>{s.value}</div>
            <div style={{ fontSize:"0.68rem",color:T.textMuted,marginTop:2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display:"flex",gap:6,marginBottom:18,background:T.bg,borderRadius:12,padding:4,width:"fit-content" }}>
        {[
          { key:"riders", label:"All Riders" },
          { key:"cash",   label:`💰 Cash Management${totalCash > 0 ? ` · ₹${totalCash}` : ""}` },
        ].map(tab => (
          <button key={tab.key} onClick={() => setActiveTab(tab.key)}
            style={{ background:activeTab===tab.key?T.white:"transparent",border:"none",borderRadius:9,padding:"7px 14px",fontWeight:700,fontSize:"0.78rem",color:activeTab===tab.key?T.primary:T.textSub,cursor:"pointer",fontFamily:"inherit",boxShadow:activeTab===tab.key?"0 1px 4px rgba(0,0,0,0.08)":"none" }}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* ── Tab: All Riders ── */}
      {activeTab === "riders" && (
        <>
          {loading ? (
            <div style={{ textAlign:"center",padding:60,color:T.textMuted }}>
              <Loader2 size={28} color={T.primary} className="spin" style={{ marginBottom:10 }}/>
              <div>Loading riders...</div>
            </div>
          ) : riders.length === 0 ? (
            <div style={{ textAlign:"center",padding:60 }}>
              <Bike size={44} color={T.border} style={{ marginBottom:12 }}/>
              <div style={{ color:T.textMuted,fontWeight:600 }}>Koi riders nahi — Add karo!</div>
            </div>
          ) : (
            <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14 }}>
              {riders.map((r, i) => (
                <RiderCard key={r._id} r={r} i={i}
                  onToggleActive={handleToggleActive}
                  onToggleOnline={handleToggleOnline}
                  onVerify={handleVerify}
                  onEdit={() => setModal(r)}
                  onCash={() => setCashModal(r)}
                />
              ))}
            </div>
          )}
        </>
      )}

      {/* ── Tab: Cash Management ── */}
      {activeTab === "cash" && (
        <div>
          {ridersWithCash.length === 0 ? (
            <div style={{ textAlign:"center",padding:60 }}>
              <Wallet size={44} color={T.border} style={{ marginBottom:12 }}/>
              <div style={{ color:T.textMuted,fontWeight:600 }}>Kisi rider ke paas pending cash nahi hai</div>
            </div>
          ) : (
            <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
              {ridersWithCash.map(r => {
                const pending = (r.cashDeposits || []).filter(d => d.status === "pending");
                return (
                  <div key={r._id} style={{ background:T.white,borderRadius:14,border:`1.5px solid ${pending.length > 0 ? T.yellow : T.border}`,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",boxShadow:"0 2px 8px rgba(0,0,0,0.04)" }}>
                    <div style={{ display:"flex",alignItems:"center",gap:12 }}>
                      <div style={{ width:40,height:40,borderRadius:"50%",background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,display:"flex",alignItems:"center",justifyContent:"center" }}>
                        <span style={{ fontWeight:900,color:"#fff",fontSize:"1rem" }}>{r.name?.charAt(0)}</span>
                      </div>
                      <div>
                        <div style={{ fontWeight:700,fontSize:"0.9rem",color:T.text }}>{r.name}</div>
                        <div style={{ fontSize:"0.7rem",color:T.textSub }}>{r.phone} · {r.area || "Akola"}</div>
                        {pending.length > 0 && (
                          <div style={{ display:"inline-flex",alignItems:"center",gap:4,marginTop:3,background:T.yellowLight,border:`1px solid #fde68a`,borderRadius:100,padding:"2px 8px" }}>
                            <Clock size={10} color={T.yellow}/>
                            <span style={{ fontSize:"0.62rem",fontWeight:700,color:T.yellow }}>{pending.length} pending request{pending.length > 1 ? "s" : ""}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                      <div style={{ textAlign:"right" }}>
                        <div style={{ fontWeight:800,fontSize:"1.1rem",color:T.primary }}>₹{r.cashBalance || 0}</div>
                        <div style={{ fontSize:"0.65rem",color:T.textMuted }}>pending</div>
                      </div>
                      <button onClick={() => setCashModal(r)}
                        style={{ background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:9,padding:"7px 12px",fontWeight:700,fontSize:"0.75rem",color:T.primary,cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",gap:5 }}>
                        <Wallet size={13}/> Manage
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Modals */}
      {modal && (
        <RiderModal
          rider={modal === "add" ? null : modal}
          onClose={() => setModal(null)}
          onSave={handleSave}
        />
      )}

      {cashModal && (
        <CashModal
          rider={cashModal}
          onClose={() => setCashModal(null)}
          onApproved={handleCashApproved}
        />
      )}
    </div>
  );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// RIDER CARD
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function RiderCard({ r, i, onToggleActive, onToggleOnline, onVerify, onEdit, onCash }) {
  return (
    <div style={{ background:T.white,borderRadius:16,border:r.isOnline?`2px solid ${T.green}`:`1.5px solid ${T.border}`,padding:18,animation:`fadeUp .3s ${i*.05}s ease both`,boxShadow:r.isOnline?"0 0 0 3px rgba(22,163,74,0.08)":"none",position:"relative" }}>

      {/* Online badge */}
      {r.isOnline && (
        <div style={{ position:"absolute",top:12,right:12,display:"flex",alignItems:"center",gap:5,background:T.greenLight,border:`1px solid ${T.green}33`,borderRadius:100,padding:"3px 10px" }}>
          <div className="pulse" style={{ width:7,height:7,borderRadius:"50%",background:T.green }}/>
          <span style={{ fontSize:"0.65rem",fontWeight:800,color:T.green }}>ONLINE</span>
        </div>
      )}

      {/* Cash badge */}
      {(r.cashBalance || 0) > 0 && (
        <div style={{ position:"absolute",top: r.isOnline ? 40 : 12,right:12,background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:100,padding:"2px 8px" }}>
          <span style={{ fontSize:"0.62rem",fontWeight:800,color:T.primary }}>💰 ₹{r.cashBalance}</span>
        </div>
      )}

      {/* Top Row */}
      <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:14,paddingRight:80 }}>
        <div style={{ width:44,height:44,borderRadius:"50%",background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,display:"flex",alignItems:"center",justifyContent:"center",position:"relative",flexShrink:0 }}>
          <span style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,color:"#fff",fontSize:"1.1rem" }}>{r.name?.charAt(0)}</span>
          {r.isOnline && (
            <div className="pulse" style={{ position:"absolute",bottom:0,right:0,width:13,height:13,borderRadius:"50%",background:T.green,border:"2px solid #fff" }}/>
          )}
        </div>
        <div style={{ flex:1,minWidth:0 }}>
          <div style={{ fontWeight:700,fontSize:"0.9rem",color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{r.name}</div>
          <div style={{ fontSize:"0.7rem",color:T.textSub }}>{r.area || "Akola"} · {r.vehicleType}</div>
          {r.isVerified ? (
            <div style={{ display:"inline-flex",alignItems:"center",gap:3,marginTop:3,background:T.greenLight,borderRadius:100,padding:"1px 7px" }}>
              <CheckCircle size={10} color={T.green}/>
              <span style={{ fontSize:"0.58rem",fontWeight:700,color:T.green }}>Verified</span>
            </div>
          ) : (
            <button onClick={() => onVerify(r._id)}
              style={{ display:"inline-flex",alignItems:"center",gap:3,marginTop:3,background:T.yellowLight,border:"none",borderRadius:100,padding:"2px 8px",cursor:"pointer",fontFamily:"inherit" }}>
              <CheckCircle size={10} color={T.yellow}/>
              <span style={{ fontSize:"0.58rem",fontWeight:700,color:T.yellow }}>Verify karo</span>
            </button>
          )}
        </div>
        <div onClick={() => onToggleActive(r._id)} style={{ cursor:"pointer",color:r.isActive?T.primary:T.textMuted,flexShrink:0 }}>
          {r.isActive ? <ToggleRight size={26}/> : <ToggleLeft size={26}/>}
        </div>
      </div>

      {/* Email */}
      {r.email ? (
        <div style={{ display:"flex",alignItems:"center",gap:6,background:T.primaryLight,borderRadius:8,padding:"5px 10px",marginBottom:10 }}>
          <Mail size={12} color={T.primary}/>
          <span style={{ fontSize:"0.7rem",color:T.primary,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{r.email}</span>
        </div>
      ) : (
        <div style={{ display:"flex",alignItems:"center",gap:6,background:T.redLight,borderRadius:8,padding:"5px 10px",marginBottom:10 }}>
          <Mail size={12} color={T.red}/>
          <span style={{ fontSize:"0.7rem",color:T.red,fontWeight:600 }}>Email missing!</span>
        </div>
      )}

      {/* Stats */}
      <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,marginBottom:14 }}>
        <div style={{ background:T.bg,borderRadius:8,padding:"8px",textAlign:"center" }}>
          <div style={{ fontWeight:700,fontSize:"0.82rem",color:T.text }}>{r.totalOrders || 0}</div>
          <div style={{ fontSize:"0.58rem",color:T.textMuted }}>Orders</div>
        </div>
        <div style={{ background:T.bg,borderRadius:8,padding:"8px",textAlign:"center" }}>
          <div style={{ fontWeight:700,fontSize:"0.82rem",color:T.yellow }}>{r.rating ? `⭐ ${r.rating}` : "New"}</div>
          <div style={{ fontSize:"0.58rem",color:T.textMuted }}>Rating</div>
        </div>
        <div style={{ background:r.isOnline?T.greenLight:T.bg,borderRadius:8,padding:"8px",textAlign:"center",border:r.isOnline?`1px solid ${T.green}33`:"none" }}>
          <div style={{ fontWeight:700,fontSize:"0.75rem",color:r.isOnline?T.green:T.textMuted }}>
            {r.isOnline ? "🟢 Online" : "⚪ Offline"}
          </div>
          <div style={{ fontSize:"0.58rem",color:T.textMuted }}>Status</div>
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ display:"flex",gap:6,flexWrap:"wrap" }}>
        <a href={`tel:${r.phone}`}
          style={{ flex:1,background:T.greenLight,border:"none",borderRadius:9,padding:"8px",fontWeight:700,fontSize:"0.75rem",cursor:"pointer",color:T.green,display:"flex",alignItems:"center",justifyContent:"center",gap:4,textDecoration:"none",minWidth:0 }}>
          <Phone size={11}/> Call
        </a>
        <button onClick={onEdit}
          style={{ flex:1,background:T.primaryLight,border:"none",borderRadius:9,padding:"8px",fontWeight:700,fontSize:"0.75rem",cursor:"pointer",color:T.primary,fontFamily:"inherit",minWidth:0 }}>
          Edit
        </button>
        <button onClick={() => onToggleOnline(r)}
          style={{ flex:1,background:r.isOnline?T.redLight:T.blueLight,border:"none",borderRadius:9,padding:"8px",fontWeight:700,fontSize:"0.72rem",cursor:"pointer",color:r.isOnline?T.red:T.blue,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:4,minWidth:0 }}>
          {r.isOnline ? <><WifiOff size={11}/> Offline</> : <><Wifi size={11}/> Online</>}
        </button>
        <button onClick={onCash}
          style={{ flex:1,background:(r.cashBalance||0)>0?T.primaryLight:T.bg,border:"none",borderRadius:9,padding:"8px",fontWeight:700,fontSize:"0.72rem",cursor:"pointer",color:(r.cashBalance||0)>0?T.primary:T.textMuted,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:4,minWidth:0 }}>
          <Wallet size={11}/> Cash
        </button>
      </div>
    </div>
  );
}